<template>
    <div class="board-wrapper"style="background-color: yellow;">
        <svg :width="svgWidth" :height="svgHeight">
            <defs>
                <clipPath
                    v-for="cell in cells"
                    :key="`clip-${cell.row}-${cell.col}`"
                    :id="`clip-${cell.row}-${cell.col}`"
                >
                    <polygon :points="cell.points"/>
                </clipPath>
            </defs>

            <g v-for="cell in cells" :key="`${cell.row}-${cell.col}`">
                    <g
                        :clip-path="`url(#clip-${cell.row}-${cell.col})`"
                        @click="onCellClick(cell.row, cell.col)"
                        style="cursor: pointer"
                    >
                    <polygon :points="cell.points" :fill="cell.rendered.bg"/>

                    <template v-for="(el, i) in cell.rendered.elements" :key="i">
                        <ellipse
                            v-if="el.tag === 'ellipse'"
                            :cx="el.cx" :cy="el.cy" :rx="el.rx" :ry="el.ry"
                            :fill="el.fill" :opacity="el.opacity"
                            :stroke="el.stroke" :stroke-width="el.strokeWidth"
                            :transform="el.transform"
                        />
                        <circle
                            v-else-if="el.tag === 'circle'"
                            :cx="el.cx" :cy="el.cy" :r="el.r"
                            :fill="el.fill" :opacity="el.opacity"
                        />
                        <polygon
                            v-else-if="el.tag === 'polygon'"
                            :points="el.points"
                            :fill="el.fill" :opacity="el.opacity"
                        />
                        <line
                            v-else-if="el.tag === 'line'"
                            :x1="el.x1" :y1="el.y1" :x2="el.x2" :y2="el.y2"
                            :stroke="el.stroke" :stroke-width="el.strokeWidth"
                            :stroke-linecap="el.strokeLinecap"
                        />
                    </template>


                    <g v-if="cell.number">
                      <circle
                          :cx="cell.cx"
                          :cy="cell.cy"
                          r="22"
                          fill="#f5f0e8"
                          stroke="#c8b89a"
                          stroke-width="2"
                      />
                      <text
                          :x="cell.cx"
                          :y="cell.cy - 1"
                          text-anchor="middle"
                          dominant-baseline="central"
                          :fill="[6, 8].includes(cell.number) ? '#c62828' : '#2c1810'"
                          :font-size="cell.number >= 10 ? '18' : '22'"
                          font-weight="700"
                          font-family="serif"
                      >{{ cell.number }}</text>
                      <!-- крапки під числом (кількість = ймовірність) -->
                      <g :transform="`translate(${cell.cx}, ${cell.cy + 14})`">
                          <circle
                              v-for="(_, di) in dots(cell.number)"
                              :key="di"
                              :cx="(di - (dots(cell.number).length - 1) / 2) * 5"
                              cy="0"
                              r="1.8"
                              :fill="[6, 8].includes(cell.number) ? '#c62828' : '#2c1810'"
                          />
                      </g>
                  </g>
                    <!-- рамка поверх -->
                    <polygon :points="cell.points" fill="none" stroke="#333" stroke-width="1" opacity="0.3"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { geks } from '../composables/geks'
import { renderCell } from '../composables/cellTypes'

const { board, makeMove, game } = geks()

const SIZE     = 5
const HEX_SIZE = 90
const PADDING  = 150
const HEX_W    = Math.sqrt(3) * HEX_SIZE
const HEX_H    = HEX_SIZE * 1.5

const HIDDEN = new Set(['0-0','0-1','1-0','3-4','4-3','4-4'])


function hexOffsetX(col, row) { return PADDING + col * HEX_W + row * (HEX_W / 2) }
function hexOffsetY(row)       { return PADDING + row * HEX_H }

function hexPoints(col, row) {
    const cx = hexOffsetX(col, row)
    const cy = hexOffsetY(row)
    return Array.from({ length: 6 }, (_, i) => {
        const angle = Math.PI / 180 * (60 * i - 30)
        return `${cx + HEX_SIZE * Math.cos(angle)},${cy + HEX_SIZE * Math.sin(angle)}`
    }).join(' ')
}

function dots(number) {
    const count = { 2:1, 3:2, 4:3, 5:4, 6:5, 8:5, 9:4, 10:3, 11:2, 12:1 }
    return Array(count[number] ?? 0).fill(0)
}

const cells = computed(() =>
    Array.from({ length: SIZE }, (_, row) =>
        Array.from({ length: SIZE }, (_, col) => {
            const key  = `${row}-${col}`
            const cx   = hexOffsetX(col, row)
            const cy   = hexOffsetY(row)
            return {
                row, col, cx, cy,
                points:   hexPoints(col, row),
            }
        })
    ).flat().filter(c => !HIDDEN.has(`${c.row}-${c.col}`)).map((cell, index) => {
      //console.log(game.value.id)
      let c = game.value.Cells[index]
      cell["rendered"] = renderCell(cell.cx, cell.cy)[c.Type]
      cell["number"] = c.Number
      return cell
    })
)

const svgWidth  = computed(() => hexOffsetX(SIZE-1, SIZE-1) + HEX_SIZE*2 + PADDING)
const svgHeight = computed(() => hexOffsetY(SIZE-1) + HEX_SIZE*2 + PADDING)

function cellClass(row, col) {
    const cell = board.value?.[row]?.[col]
    return { 'hex-cell': true, 'hex-red': cell==='red', 'hex-blue': cell==='blue', 'hex-empty': !cell }
}

function colLabel(col) { return String.fromCharCode(65 + col) }

async function onCellClick(row, col) {
    if (board.value?.[row]?.[col]) return
    //await makeMove(row, col)
}
</script>